import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export function Env(props) {
  const { nodes, materials } = useGLTF("/sc_turismo_env.gltf");
  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.T2.geometry}
        material={materials.Material}
        position={[0, -0.51942158, 0]}
        scale={12.72251225}
      />
      <mesh
        geometry={nodes.TS3.geometry}
        material={materials.B_stand_large}
        position={[-0.23680365, -0.3081848, 2.69656801]}
        rotation={[0, Math.PI / 2, 0]}
      />
      <mesh
        geometry={nodes.TS1.geometry}
        material={materials["B-floor"]}
        position={[-0.09539177, 0.27230701, 0.11807358]}
        scale={[1.81475484, 1.03227985, 1.81475484]}
      />
    </group>
  );
}

useGLTF.preload("/sc_turismo_env.gltf");